// Componente Home/Home-Private para usuarios autenticados
// Muestra un panel de control con métricas y acciones principales

import React from 'react';
import { Link } from 'react-router-dom';
import { FiCreditCard, FiTrendingUp, FiUsers, FiMessageCircle } from 'react-icons/fi';
import Button from '../../components/UI/Button';

/**
 * Componente Home
 * 
 * Home principal para usuarios autenticados
 * Muestra métricas básicas del sistema y acciones rápidas
 */
const Home = () => {
  return (
    <>
      {/* Bienvenida */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900">
          ¡Bienvenido de nuevo!
        </h2>
        <p className="mt-1 text-gray-600">
          Aquí tienes un resumen de la actividad reciente del sistema.
        </p>
      </div>

      {/* Tarjetas de Acciones Rápidas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <Link to="/planes" className="group">
          <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between mb-4">
              <FiCreditCard className="h-8 w-8 text-primary" />
              <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-primary transition-colors">
                Gestión
              </span>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Planes
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Administra tu suscripción y explora planes disponibles
            </p>
          </div>
        </Link>

        <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between mb-4">
            <FiTrendingUp className="h-8 w-8 text-green-500" />
            <span className="text-xs text-gray-500 dark:text-gray-400">
              Estadísticas
            </span>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Actividad
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Tu actividad reciente en la plataforma
          </p>
        </div>

        <Link to="/interacciones" className="group">
          <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between mb-4">
              <FiUsers className="h-8 w-8 text-purple-500" />
              <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-purple-500 transition-colors">
                Social
              </span>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Interacciones
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Matches y conexiones recientes
            </p>
          </div>
        </Link>

        <Link to="/chats" className="group">
          <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center justify-between mb-4">
              <FiMessageCircle className="h-8 w-8 text-blue-500" />
              <span className="text-xs text-gray-500 dark:text-gray-400 group-hover:text-blue-500 transition-colors">
                Mensajes
              </span>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Chats
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Conversaciones activas y mensajes nuevos
            </p>
          </div>
        </Link>
      </div>

      {/* Sección de Suscripción */}
      <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg shadow-lg p-8 text-white mb-8">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="mb-6 lg:mb-0">
            <h3 className="text-2xl font-bold mb-3">
              Desbloquea Todo el Potencial de Amarsi
            </h3>
            <p className="text-primary-100 mb-4 max-w-2xl">
              Obtén acceso a características exclusivas, matches ilimitados y herramientas avanzadas 
              para mejorar tus conexiones. Actualiza a un plan premium hoy mismo.
            </p>
            <Link to="/planes">
              <Button variant="white" size="lg">
                Ver Planes Disponibles
              </Button>
            </Link>
          </div>
          <div className="text-center lg:text-right">
            <div className="text-4xl font-bold mb-2">
              PREMIUM
            </div>
            <div className="text-primary-200">
              Características exclusivas
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Home;
